"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var idGenerator = function idGenerator(prefix) {
  var index = 1;
  return function (suffix) {
    if (suffix) {
      return "".concat(prefix).concat(index + 1).concat(suffix);
    }
    return "".concat(prefix).concat(index + 1);
  };
};
var _default = idGenerator;
exports.default = _default;